export default __webpack_public_path__ + "static/media/l.4f7db9a8.jpg";